var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"md":"6","sm":"12"}},[_c('update-profile')],1),_c('v-col',{attrs:{"md":"6","sm":"12"}},[_c('change-password')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }